import { render, staticRenderFns } from "./YagiHiroba.vue?vue&type=template&id=83200e96&scoped=true&"
import script from "./YagiHiroba.vue?vue&type=script&lang=js&"
export * from "./YagiHiroba.vue?vue&type=script&lang=js&"
import style0 from "./YagiHiroba.vue?vue&type=style&index=0&id=83200e96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83200e96",
  null
  
)

export default component.exports